module.exports = __webpack_public_path__ + "static/img/bg3@2x.8902779.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/bg3@2x.png
// module id = OMCV
// module chunks = 2